module.exports = __webpack_public_path__ + "img/叉车AGV.f2d122a8.jpg";